// Client compliance dashboard: the Plan of Care dropdown in each client row shows the selected plan's
// cells (rendered server-side with data-poc-cell="<plan id>") and hides the others in that row.
// The choice is remembered per client in this browser (localStorage) and restored on page load.
// Listeners are bound once on document so they keep working across Turbolinks page visits.
const STORAGE_KEY = 'clientDashboardPlanOfCare';

const loadSelections = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
};

const saveSelection = (clientId, planId) => {
  try {
    const selections = loadSelections();
    selections[clientId] = planId;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selections));
  } catch (e) {
    // Storage unavailable (private window, blocked site data): the choice just isn't remembered
  }
};

const showPlan = (select, planId) => {
  select.value = planId;
  const group = select.closest('[data-poc-group]');
  if (!group) return;

  group.querySelectorAll('[data-poc-cell]').forEach((cell) => {
    cell.classList.toggle('d-none', cell.dataset.pocCell !== planId);
  });
};

// Every dropdown for a client (the desktop and mobile layouts each have one)
const selectsFor = (clientId) => document.querySelectorAll(`select.poc-select[data-client-id="${clientId}"]`);

document.addEventListener('change', (event) => {
  const select = event.target;
  if (!select.matches || !select.matches('select.poc-select')) return;

  const { clientId } = select.dataset;
  selectsFor(clientId).forEach((s) => showPlan(s, select.value));
  saveSelection(clientId, select.value);
});

document.addEventListener('turbolinks:load', () => {
  const selections = loadSelections();
  document.querySelectorAll('select.poc-select').forEach((select) => {
    const planId = selections[select.dataset.clientId];
    // Ignore a remembered plan that no longer exists for this client
    if (planId !== undefined && [...select.options].some((o) => o.value === planId)) {
      showPlan(select, planId);
    }
  });
});
